import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { SocialLoginButton } from "@faire/retailer-visitor-shared/components/AppSignIn/components/__internal__/SocialLoginButton";
import { convertErrorToLoginError } from "@faire/retailer-visitor-shared/components/AppSignIn/components/convertErrorToLoginError";
import { logErrorSignIn } from "@faire/retailer-visitor-shared/components/AppSignIn/components/logErrorSignIn";
import { LoginWrapper } from "@faire/retailer-visitor-shared/components/AppSignIn/components/styled";
import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { useFetchHCaptchaToken } from "@faire/retailer-visitor-shared/hooks/hCaptcha/useFetchHCaptchaToken";
import { useHCaptchaLogin } from "@faire/retailer-visitor-shared/hooks/hCaptcha/useHCaptchaLogin";
import { getSettingEnableHCaptchaForLoginData } from "@faire/retailer-visitor-shared/settings/getSettingEnableHCaptchaForLoginData";
import { useSSOErrorStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOErrorStore";
import { useSSOPasswordStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOPasswordStore";
import { useSSOProviderOptionsStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOProviderOptionsStore";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { emitDatadogError } from "@faire/web--source/common/datadog/rum";
import { DEPRECATED_backwardsCompatibleValues, useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Button } from "@faire/web--source/slate/Button";
import { GrowingSpacer, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import userLoginData from "@faire/web-api--source/api/user/login-data/post";
import resetPassword from "@faire/web-api--source/api/user/reset-password/userToken/post";
import { ILoginDataRequest } from "@faire/web-api--source/indigofair/data/ILoginDataRequest";
import { ISendResetPasswordRequest } from "@faire/web-api--source/indigofair/data/ISendResetPasswordRequest";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import React, { useCallback, useEffect, useState } from "react";
export var SSOView = function(param) {
    var email = param.email, userToken = param.userToken, onComplete = param.onComplete, onLogin = param.onLogin;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useState = _sliced_to_array(useState(), 2), error = _useState[0], setError = _useState[1];
    var fetchHCaptchaToken = useFetchHCaptchaToken(getSettingEnableHCaptchaForLoginData()).fetchHCaptchaToken;
    var errorMessage = useSSOErrorStore().errorMessage;
    var _useSSOProviderOptionsStore = useSSOProviderOptionsStore(), providers = _useSSOProviderOptionsStore.providers, resetProviders = _useSSOProviderOptionsStore.resetProviders;
    var userHasPassword = useSSOPasswordStore().userHasPassword;
    var _useSSOStore = useSSOStore(), userClickedSSOButton = _useSSOStore.userClickedSSOButton, setPromptSSO = _useSSOStore.setPromptSSO;
    useEffect(function() {
        if (userHasPassword) {
            logErrorSignIn("SSO", "Wrong view for user with password");
        }
    }, [
        userHasPassword
    ]);
    var onFinish = useCallback(function(result) {
        onComplete(result);
        resetProviders();
        setPromptSSO(false);
    }, [
        onComplete,
        resetProviders,
        setPromptSSO
    ]);
    // SSOView is prompted if the user has an SSO connected to their account
    // onConfirmPassword exists to confirm users password if they want to connect an SSO to their account
    // So there is no way it would be relevant here
    var onConfirmPassword = function() {};
    var onReset = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var loginData, newUserToken, e, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            6,
                            ,
                            7
                        ]);
                        if (!userToken) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            resetPassword(userToken, ISendResetPasswordRequest.build({}))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 2:
                        return [
                            4,
                            fetchHCaptchaToken(true).then(function() {
                                return userLoginData(ILoginDataRequest.build({
                                    email_address: email
                                }));
                            })
                        ];
                    case 3:
                        loginData = _state.sent();
                        newUserToken = loginData.user_token;
                        return [
                            4,
                            resetPassword(newUserToken !== null && newUserToken !== void 0 ? newUserToken : "", ISendResetPasswordRequest.build({}))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        error = convertErrorToLoginError(e, strictLocalize);
                        emitDatadogError(error);
                        setError(error);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        onFinish({
                            nextView: View.RESET_PASSWORD
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function onReset() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderSocialLoginButton = function(provider, index) {
        return /*#__PURE__*/ _jsx(SocialLoginButton, {
            provider: provider,
            onFinish: onFinish,
            onLogin: onLogin,
            onConfirmPassword: onConfirmPassword,
            sourceId: "sign_in_modal_sso_view"
        }, index);
    };
    var cumulativeErrorMessage = userClickedSSOButton ? errorMessage : error === null || error === void 0 ? void 0 : error.message;
    useHCaptchaLogin();
    var renderPasswordButton = function() {
        if (userHasPassword) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Button, {
            variant: "tertiary",
            onClick: onReset,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "PZ5Dke",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Reset Password"
                    }
                ]
            })
        });
    };
    var Link = useCallback(function(chunks) {
        return /*#__PURE__*/ _jsx(EmbeddedLink, {
            linkTo: "/?signIn=1",
            onClick: function() {
                onFinish({
                    nextView: View.ENTER_EMAIL
                });
            },
            children: chunks
        });
    }, [
        onFinish
    ]);
    var LinkUsePwdCallBackFormatting = useCallback(function(chunks) {
        return /*#__PURE__*/ _jsx(Button, {
            variant: "tertiary",
            style: {
                display: "inline"
            },
            linkTo: "/?signIn=1",
            onClick: function() {
                onFinish({
                    nextView: View.ENTER_PASSWORD
                });
            },
            children: chunks
        });
    }, [
        onFinish
    ]);
    var hasOktaProvider = providers.includes(SocialSignOnProvider.OKTA);
    return /*#__PURE__*/ _jsxs(LoginWrapper, {
        children: [
            /*#__PURE__*/ _jsx(GrowingSpacer, {}),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "cbJZwa",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Welcome back!"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "wzsDo7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Continue as "
                        },
                        {
                            type: 1,
                            value: "email"
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        email: email
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "6ptCJH",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Not you? "
                        },
                        {
                            type: 8,
                            value: "Link",
                            children: [
                                {
                                    type: 0,
                                    value: "Choose a different account"
                                }
                            ]
                        }
                    ],
                    values: DEPRECATED_backwardsCompatibleValues({
                        Link: Link
                    })
                })
            }),
            hasOktaProvider && /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "uJ/GbX",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Want to login with a password? "
                        },
                        {
                            type: 8,
                            value: "LinkUsePwdCallBackFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Use password"
                                }
                            ]
                        }
                    ],
                    values: {
                        LinkUsePwdCallBackFormatting: LinkUsePwdCallBackFormatting
                    }
                })
            }),
            cumulativeErrorMessage ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        color: Core.text.critical,
                        role: "alert",
                        align: "center",
                        children: cumulativeErrorMessage
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    })
                ]
            }) : null,
            providers.map(renderSocialLoginButton),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            renderPasswordButton(),
            /*#__PURE__*/ _jsx(GrowingSpacer, {})
        ]
    });
};
